import React, { useState } from "react";
import CustomTab from "@/components/dataTableComponents/CustomTab";
import { Formik, Form, ErrorMessage } from "formik";
import { Box, Button, CircularProgress } from "@mui/material";
import * as Yup from "yup";
import FormikFileUpload from "@/components/forms/FormikFileUpload";
import { DownloadIcon, FileDownloadOutlinedIcon, FileUploadOutlinedIcon } from "@/icons";
import ReusableButton from "@/components/buttons/StyledButton";
import CardContent from "@/pages/attendanceManagement/components/CardContent";
import { useDateTypeImportMutation, useGetDateTypeSampleQuery, useGetShiftRosterSampleQuery, useShiftRosterImportMutation } from "@/api/services/attendanceManagement/shiftRosterImport/ShiftRosterImport";
import { toast } from "@/components/toastify";
import { StyledButton } from "@/components";

const ShiftRosterExcelImport = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [uploading, setUploading] = useState(false);
  const tabsData = [
    { name: "Shift Roster Upload" },
    { name: "DayType Upload" },
  ];

  const { data: dateTypeSample = [], } = useGetDateTypeSampleQuery();
  const { data: shiftRosterSample = [], } = useGetShiftRosterSampleQuery();

  const [shiftRosterImport] = useShiftRosterImportMutation();
  const [dateTypeImport] = useDateTypeImportMutation();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSubmit = async (values, { resetForm }) => {
    if (!values.file) {
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", values?.file);

    try {
      const response =
        activeTab === 0
          ? await shiftRosterImport({ formData }).unwrap()
          : await dateTypeImport({ formData }).unwrap();

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "file.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast(
        "success",
        activeTab === 0
          ? "Shift Roster Uploaded Successfully!"
          : "Day Type Uploaded Successfully!"
      );

      resetForm(); // Reset the form after successful upload
    } catch (err) {
      console.error("Upload failed:", err);
    } finally {
      setUploading(false);
    }
  };


  const handleDownload = (sampleData, fileName) => {
    if (!sampleData || !(sampleData instanceof Blob)) {
      return;
    }

    const url = URL.createObjectURL(sampleData);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  // const validationSchema = Yup.object().shape({
  //   file: Yup.mixed().required("File is required"),
  // });

  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("File is required")
      .test("fileFormat", "Only Excel files are allowed", (value) => {
        if (!value) return false; // No file uploaded
        return value && ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].includes(value.type);
      }),
  });

  const renderContent = () => {

    return (
      <>
        <br />
        Click the link to download a sample Excel file <ReusableButton
          label="Download Sample File"
          icon={<DownloadIcon />}
          // onClick={handleDownload}
          onClick={() => handleDownload(activeTab === 1 ? dateTypeSample : shiftRosterSample, "sample.xlsx")}
          size="small"
          variant="outlined"
          type="button"
          sx={{
            width: "250px", height: "32px",
            borderRadius: "4px",
            color: "hsl(38,92%,50%)",
            background: "rgb(253,239,214)",
            border: "1px solid hsl(38,92%,50%)",
            "&:hover": {
              color: "hsl(38,92%,50%)",
              background: "rgb(253,239,214)",
              border: "1px solid hsl(38,92%,50%)",
            },
          }}
        />

        <br />
        <Formik
          initialValues={{ file: null }}
          onSubmit={(values, actions) => handleSubmit(values, actions)}
          validationSchema={validationSchema}
        >

          {({ isSubmitting, setFieldValue, resetForm }) => (
            <Form>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <FormikFileUpload
                    placeholder="Choose File"
                    name="file"
                    label="Upload"
                    required
                    width="30%"
                    // handleChange={customHandleFileChange}
                    handleChange={(event, file) =>
                      setFieldValue("file", file)
                    }
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 2,
                  }}
                >

                  <StyledButton type="submit"
                    //  label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                    label={
                      isSubmitting ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        <>
                          <FileUploadOutlinedIcon sx={{ mr: 1 }} />
                          Import
                        </>
                      )
                    }

                    variant="contained" />
                  {/* <Button
                    type="submit"
                    sx={{
                      backgroundColor: "#E3EDFC",
                          color: "#0D3C83",
                          border: "1px solid #0D3C83"
                      // backgroundColor: "#0D3C83",
                      // color: "#fff",
                      // borderRadius: "6px",
                      // padding: "8px 16px",
                      // "&:hover": {
                      //   backgroundColor: "#0A2D66",
                      // },
                    }}


                    variant="contained"
                    disabled={isSubmitting || uploading}
                    startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : <FileUploadOutlinedIcon />}
                  >
                    {uploading ? "Uploading..." : "Import"}
                  </Button> */}
                 
                </Box>
              </Box>
            </Form>
          )}
        </Formik>

      </>
    );
  };

  return (
    <>
      <CardContent title="Shift Roster Excel Import">
        <CustomTab
          tabs={tabsData}
          value={activeTab}
          renderContent={renderContent()}
          onChange={handleTabChange}
        />
      </CardContent>
    </>
  );
};

export default ShiftRosterExcelImport;
